import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,

} from '@material-ui/core';
import { modificarPisoConsultorio } from '../../../../actions/turnos/efectorHorarios';



export const ModalPisoConsultorio = (props) => {
    const dispatch = useDispatch();
    const { info, disabled } = props;

    const [piso, setPiso] = useState(info?.piso);
    const [consultorio, setConsultorio] = useState(info?.consultorio);
    const [recepcion, setRecepcion] = useState(info?.recepcion);

    const onSubmitHandler = () => {
        const parametros = {
            idEfector: info.idEfector,
            idCentro: info.idCentro,
            idEspecialidad: info.idEspecialidad,
            idEfHorario: info.idEfHorario,
            piso: piso,
            consultorio: consultorio,
            recepcion: recepcion
        }
        dispatch(modificarPisoConsultorio(parametros));
        props.close();
    };

    return (
        <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
            <DialogTitle>Modificación</DialogTitle>
            <DialogContent>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Piso"
                                name="piso"
                                value={piso}
                                onChange={(e) => setPiso(e.target.value)}
                                disabled={disabled}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Consultorio"
                                name="consultorio"
                                value={consultorio}
                                onChange={(e) => setConsultorio(e.target.value)}
                                disabled={disabled}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Recepción"
                                name="recepcion"
                                value={recepcion}
                                onChange={(e) => setRecepcion(e.target.value)}
                                disabled={disabled}
                                validators={['required']}
                                errorMessages={['Este campo es requerido']}
                            />
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            margin: '1rem 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={props.close}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            disabled={props.disabled}
                            color="primary"
                            onClick={onSubmitHandler}
                        >
                            Actualizar
                        </Button>
                    </div>
            </DialogContent>
        </Dialog>
    )
}
